"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _vue = require("vue");
var _merchant = require("@/api/merchant");
// 假设这是获取商户列表的 API 接口
var _default = {
  __name: 'merchantSelect',
  props: {},
  emits: ['update'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var merchantList = (0, _vue.ref)([]);
    var merchantId = (0, _vue.ref)('');
    (0, _vue.onMounted)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _merchant.getMerchantList)().then(function (res) {
                console.log(res);
                if (res.data) {
                  merchantList.value = res.data;
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _vue.watch)(function () {
      return merchantId.value;
    }, function (newValue) {
      console.log('newValue', newValue);
      emit('update', newValue);
    });
    expose({
      merchantList: merchantList,
      merchantId: merchantId
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      merchantList: merchantList,
      merchantId: merchantId
    };
  }
};
exports.default = _default;